import { jsx as _jsx } from "react/jsx-runtime";
import { AnalyticsAttributesProvider, Markdown } from '../../components';
import { StyledMarkdown } from './UiMarkdown.styled';
export default function UiMarkdown({ model }) {
    const { content, entryTitle, orderedListAppearance, textSize } = model.content;
    return (_jsx(AnalyticsAttributesProvider, Object.assign({ value: {
            eventContainer: model.type,
            labelEnglish: entryTitle
        } }, { children: _jsx(StyledMarkdown, Object.assign({ orderedListAppearance: orderedListAppearance, textSize: textSize }, { children: _jsx(Markdown, { children: content }, void 0) }), void 0) }), void 0));
}
//# sourceMappingURL=UiMarkdown.js.map